import * as React from "react";
const SvgFiRrShirt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-shirt_svg__a)">
      <path
        fill="#062147"
        d="m21.773 3.98-1.137-.758-1.765-1.765a5.03 5.03 0 0 0-3.533-1.463h-.005l-6.687.005A5.03 5.03 0 0 0 5.107 1.47L3.362 3.224l-1.136.757A4.99 4.99 0 0 0-.001 8.14V19c0 2.757 2.243 5 5 5h1a1 1 0 0 0 0-2h-1c-1.654 0-3-1.346-3-3V8.14c0-1.004.5-1.937 1.336-2.495l.537-.358 5.89 5.89-1.647 7.338c-.299 1.047-.007 2.176.729 2.91l1.777 1.964c.352.389.854.612 1.378.612H12c.523 0 1.026-.222 1.378-.61l1.707-1.884a3.02 3.02 0 0 0 .841-2.812l-1.689-7.52 5.889-5.888.537.358a3 3 0 0 1 1.336 2.496V19c0 1.654-1.346 3-3 3h-1a1 1 0 0 0 0 2h1c2.757 0 5-2.243 5-5V8.14a4.99 4.99 0 0 0-2.227-4.16zm-7.182-1.986-2.592 2.592-2.588-2.588zm-8.067.888q.24-.24.524-.418l3.807 3.807-.793 2.379-4.649-4.651zm7.125 17.233L12 21.932l-1.708-1.886c-.257-.257-.354-.633-.24-1.038l1.947-8.672 1.976 8.795c.076.337-.032.697-.326.984m.287-11.466-.793-2.38 3.805-3.804q.276.176.509.407L18.585 4z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-shirt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShirt;
